import React from 'react';
import PropTypes from 'prop-types';

export default class ProductAndOptionsWarnings extends React.PureComponent {
  static propTypes = {
    thumbCompatibleMissing: PropTypes.bool.isRequired,
    couplerMissing: PropTypes.bool.isRequired,
    noBucketSpecsAvailable: PropTypes.bool.isRequired,
    alertFasterLeadTimes: PropTypes.bool.isRequired,
    fullWidth: PropTypes.bool,
  };

  render() {
    const {
      thumbCompatibleMissing,
      couplerMissing,
      noBucketSpecsAvailable,
      alertFasterLeadTimes,
      fullWidth,
    } = this.props;

    return (
      <div
        className={`row ${fullWidth ? 'card-deck' : 'justify-content-center'}`}
      >
        <div className={`${fullWidth ? 'banner-container' : ''}`}>
          {thumbCompatibleMissing && (
            <div
              className={`alert alert-warning ${fullWidth ? 'card-body' : ''}`}
            >
              <i className="fa fa-info-circle fa-lg text-danger"></i> No thumbs
              were found that are compatible with the selected bucket
              configuration. Please contact AMI for assistance
            </div>
          )}
          {couplerMissing && (
            <div
              className={`alert alert-warning ${fullWidth ? 'card-body' : ''}`}
            >
              <i className="fa fa-info-circle fa-lg text-danger"></i> Lugging
              must be specified before a thumb can be added to this quote.
            </div>
          )}
          {noBucketSpecsAvailable && (
            <div
              className={`alert alert-warning ${fullWidth ? 'card-body' : ''}`}
            >
              <i className="fa fa-info-circle fa-lg text-danger"></i> Thumb
              width cannot be confirmed until bucket specifications are
              provided.
            </div>
          )}
          {alertFasterLeadTimes && (
            <div
              className={`alert alert-warning ${fullWidth ? 'card-body' : ''}`}
            >
              <i className="fa fa-info-circle fa-lg text-danger me-1"></i>
              Faster lead times are available if you get an AMI bucket with your thumb.
            </div>
          )}
        </div>
      </div>
    );
  }
}
